import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=169cd726&scoped=true&"
import script from "./Menu.vue?vue&type=script&lang=js&"
export * from "./Menu.vue?vue&type=script&lang=js&"
import style0 from "@@/core/pages/menu/Menu/MenuStyle.css?vue&type=style&index=0&id=169cd726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169cd726",
  null
  
)

export default component.exports